import { Styles } from "react-modal";

export const customModalStyles: Styles = {
  content: {
    padding: "0px",
    // width: "412px",
    minHeight: "388px",
    maxHeight: "700px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "#2e2e2e",
    // borderRadius: "5px"
  },
  overlay: {
    background: "rgba(0, 0, 0, .7)",
    zIndex: "2",
  },
};

export const deleteModalStyles: Styles = {
  content: {
    padding: "0px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "#2e2e2e",
  },
  overlay: {
    background: "rgba(0, 0, 0, .7)",
    zIndex: "2",
  },
};

export const DowngradeCustomModal: Styles = {
  content: {
    padding: "0px",
    // width: "412px",
    // height: "388px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    background: "transparent",
    border: "none",
    // borderRadius: "5px"
  },
  overlay: {
    background: "rgba(0, 0, 0, .7)",
    zIndex: "2",
  },
};

export const TickerCustomModal: Styles = {
  content: {
    padding: "0px",
    width: !window.matchMedia("(max-width: 480px)").matches ? "500px" : "400px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    background: "transparent",
    border: "none",
  },
  overlay: {
    background: "rgba(0, 0, 0, .7)",
    zIndex: "2",
  },
};
